import React, { useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { Link } from '.'
import { IoIosCloseCircle } from 'react-icons/io'

//TODO add a solid state and color
function Tag({ children, href, rounded, closeBtn, className }) {
    const theme = useTheme()
    const [visible, setVisible] = useState(true)
    const tagStyle = css`
        display: flex;
        align-items: center;
        font-size: ${theme.fontSize.sm};
        ${'' /* border: 1px solid ${ theme.colors.secGray}; */}
        max-width: max-content;
        border-radius: ${rounded
            ? theme.borderRadius.full
            : theme.borderRadius.default};
        padding: ${theme.spacing.one} ${theme.spacing.three};
        color: ${theme.colors.medGray};
        background-color: ${theme.colors.lighterGray};
        &:hover {
            ${'' /* border-color: ${theme.colors.medGray}; */}
            cursor: pointer;
            background-color: ${theme.colors.lightGray};
            a {
                color: ${theme.colors.text};
            }
        }
        span.close {
            color: ${theme.colors.secGray};
            font-size: ${theme.fontSize.lg};
            &:hover {
                color: ${theme.colors.medGray};
            }
        }
        ${className}
    `
    return (
        <>
            {visible && (
                <div css={tagStyle}>
                    <Link href={href} color={theme.colors.medGray}>
                        {children}
                    </Link>
                    {closeBtn && (
                        <span className="close relative">
                            <IoIosCloseCircle
                                className="inline-block mr-2"
                                onClick={() => {
                                    return setVisible(false)
                                }}
                            />
                        </span>
                    )}
                </div>
            )}
        </>
    )
}

export default Tag
